export const isDev = window.location.href.indexOf('localhost') > -1;

export const baseUrl = process.env.REACT_APP_BASEURL;

export const asset = process.env.REACT_APP_ASSET;

export const DOMAIN = process.env.REACT_APP_DOMAIN;

export const token = process.env.REACT_APP_TOKEN;

export const CLIAM_APPID = process.env.REACT_APP_CLIAM_APPID;

export const COOKIE_EXPIRATION_CHECKER = process.env.REACT_APP_COOKIE_EXPIRATION_CHECKER;

export default isDev;
